export default __webpack_public_path__ + "static/media/DNo.17-0.ee876389.jpg";